import React, { PropsWithChildren } from 'react';

import { UserContextProvider } from '../user/context';
import { useUserOrganizationQuery } from '../user/useUserOrganizationQuery';
import { ServiceDisruption, ServiceDisruptionReasonCode } from './service-disrupted';
import { useWhoamiQuery } from './hooks/useWhoamiQuery';

type UserLoaderProps = object;

export function UserLoader(props: PropsWithChildren<UserLoaderProps>) {
  const { status, data } = useWhoamiQuery();
  const { status: organizationStatus, data: userOrganization } = useUserOrganizationQuery();

  if (status === 'pending') {
    // TODO: Loader?
    return null;
  }

  if (status === 'error') {
    // Generic error page
    return (
      <>
        <ServiceDisruption reason={ServiceDisruptionReasonCode.UserError} />
      </>
    );
  }

  // we want to wait for the org request to settle so we can render the UserContext with the resolved org
  if (organizationStatus === 'pending') {
    return null;
  }

  return (
    <>
      <UserContextProvider user={data} userOrganization={userOrganization ?? undefined}>
        {props.children}
      </UserContextProvider>
    </>
  )
}

